import React from "react";

/**
 * Sealing & Finishing icon — a gravity-feed HVLP spray gun (tilted cup on top,
 * nozzle pointing left). The `.bdrv2-ico-mist` dots burst from the nozzle on
 * tile hover / scroll-into-view (see serviceIcons.css). Edit freely; uses
 * currentColor.
 */
const ServiceSprayerIcon = () => (
  <svg
    className="bdrv2-svc-ico bdrv2-ico-sprayer"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* barrel / body */}
    <rect x="15" y="19" width="15" height="7" rx="1.5" />
    {/* nozzle tip (left) */}
    <path d="M15 21 H11 V24 H15" />

    {/* gravity-feed cup — bigger, raised off the body, joined by a short stem;
        the whole group is tilted back around its base */}
    <g transform="rotate(20 23.5 19)">
      {/* connecting stem */}
      <path d="M22 19 V14 M25 19 V14" />
      {/* cup */}
      <rect x="18" y="1" width="11" height="13" rx="3" />
      <path d="M18.5 4.5 H28.5" />
    </g>

    {/* grip / handle + trigger */}
    <path d="M26 26 L28 38 H23 L22 27" />
    <path d="M21.5 27 H25" />

    {/* spray mist cone (animated, sprays left) — larger droplets so the mist reads */}
    <g className="bdrv2-ico-mist" fill="currentColor" stroke="none">
      <circle cx="9" cy="22.5" r="2.3" />
      <circle cx="6.3" cy="19.4" r="1.9" />
      <circle cx="6.3" cy="25.6" r="1.9" />
      <circle cx="3.8" cy="17.4" r="1.6" />
      <circle cx="3.8" cy="22.5" r="1.7" />
      <circle cx="3.8" cy="27.6" r="1.6" />
      <circle cx="1.6" cy="20" r="1.4" />
      <circle cx="1.6" cy="25" r="1.4" />
    </g>
  </svg>
);

export default ServiceSprayerIcon;
